import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { styleSheet } from '../styles';

type Props = {
	field: Api.IFormField<string>;
};

export const FileFieldPlaceholder = ({ field }: Props) => {
	if (field.fieldType !== Api.FormFieldType.FileUpload) {
		return null;
	}

	return <div className={css(styleSheet.fileFieldPlaceholder)}>Respondents will be prompted to upload a file</div>;
};
